import { HUBS } from '../../types/relevancyData';
import { DATA_TYPE_FAMILIES } from './DataTypeFamilies';
const CMS_TYPES = [DATA_TYPE_FAMILIES.PAGES, DATA_TYPE_FAMILIES.SEO];
const COMMERCE_TYPES = [DATA_TYPE_FAMILIES.LINE_ITEMS, '0-3',
// DEAL
'0-7',
// PRODUCT
'0-14',
// QUOTE
'0-53',
// INVOICE
'0-69',
// SUBSCRIPTION
'0-101',
// COMMERCE_PAYMENT
'0-118',
// PAYMENT_LINK
'0-123',
// ORDER
'0-142' // CART
];
export const HUB_DATA_TYPES = {
  [HUBS.CMS]: CMS_TYPES,
  [HUBS.MARKETING]: CMS_TYPES.concat([DATA_TYPE_FAMILIES.ADS, DATA_TYPE_FAMILIES.CAMPAIGNS, DATA_TYPE_FAMILIES.CTAS, DATA_TYPE_FAMILIES.FORMS, DATA_TYPE_FAMILIES.MARKETING_EMAIL, DATA_TYPE_FAMILIES.MARKETING_EVENTS, DATA_TYPE_FAMILIES.SMS, DATA_TYPE_FAMILIES.SOCIAL, '0-20',
  // ATTRIBUTION_TOUCH_POINTS (revenue)
  '0-52',
  // CONTACT_CREATE_ATTRIBUTION
  '0-63' // DEAL_CREATE_ATTRIBUTION
  ]),
  [HUBS.COMMERCE]: COMMERCE_TYPES,
  [HUBS.SALES]: COMMERCE_TYPES.concat([DATA_TYPE_FAMILIES.DOCUMENTS, DATA_TYPE_FAMILIES.SEQUENCES, DATA_TYPE_FAMILIES.TEMPLATES, '0-4',
  // ENGAGEMENT
  '0-11',
  // CONVERSATION
  '0-20',
  // ATTRIBUTION_TOUCH_POINTS (revenue)
  '0-27',
  // TASK
  '0-46',
  // NOTE
  '0-47',
  // MEETING_EVENTS
  '0-48',
  // CALL
  '0-49',
  // EMAIL (SALES)
  '0-56',
  // CHATFLOW
  '0-60',
  // FORECAST
  '0-63',
  // DEAL_CREATE_ATTRIBUTION
  '0-72',
  // DEAL_SPLIT
  '0-136' // LEAD
  ]),
  [HUBS.SERVICE]: [DATA_TYPE_FAMILIES.FEEDBACK, DATA_TYPE_FAMILIES.HD_MESSAGES, DATA_TYPE_FAMILIES.KNOWLEDGE_BASE, '0-5',
  // TICKET
  '0-11',
  // CONVERSATION
  '0-56' // CHATFLOW
  ]
};
export const DATA_TYPE_HUBS = Object.entries(HUB_DATA_TYPES).reduce((dataTypeMap, [hub, dataTypes]) => {
  dataTypes.forEach(dataType => {
    if (!dataTypeMap[dataType]) {
      dataTypeMap[dataType] = [];
    }
    dataTypeMap[dataType].push(hub);
  });
  return dataTypeMap;
}, {});